import { clearCookie, getCookie } from './common';

let trigger = false;
function handleResponse(response) {
  if (response.status === 401 && !trigger && getCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE)) {
    trigger = true;
    clearCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE);
    clearCookie(process.env.REACT_APP_PSP_ALLOWED_PAGES_COOKIE);
    window.location.reload();
  }
  return response;
}
function get(url, token = null, customHeader = {}) {
  const headers = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${token ?? getCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE)}`,
    ...customHeader,
  };
  const requestOptions = {
    method: 'GET',
    headers,
  };
  return fetch(url, requestOptions).then(res => handleResponse(res));
}

function post(url, body, token = null) {
  const headers = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${token ?? getCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE)}`,
  };

  const requestOptions = {
    method: 'POST',
    headers,
    body: JSON.stringify(body),
  };

  return fetch(url, requestOptions).then(res => handleResponse(res));
}

function upload(url, body, token = null) {
  const headers = {
    authorization: `Bearer ${token ?? getCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE)}`,
  };

  const requestOptions = {
    method: 'POST',
    headers,
    body,
  };

  return fetch(url, requestOptions).then(res => handleResponse(res));
}

function put(url, body, token = null) {
  const headers = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${token ?? getCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE)}`,
  };
  const requestOptions = {
    method: 'PUT',
    headers,
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then(res => handleResponse(res));
}

function _delete(url, body, token = null) {
  const headers = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${token ?? getCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE)}`,
  };
  const requestOptions = {
    method: 'DELETE',
    headers,
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then(res => handleResponse(res));
}

function patch(url, body, token = null) {
  const headers = {
    'Content-Type': 'application/json',
    authorization: `Bearer ${token ?? getCookie(process.env.REACT_APP_PSP_TOKEN_COOKIE)}`,
  };
  const requestOptions = {
    method: 'PATCH',
    headers,
    body: JSON.stringify(body),
  };
  return fetch(url, requestOptions).then(res => handleResponse(res));
}

export const Fetch = {
  get,
  post,
  put,
  delete: _delete,
  patch,
  upload,
};
